export default __webpack_public_path__ + "2019 Multi-level quantum Rabi model for anharmonic vibrational polaritons.pdf";